import { HostBinding, Component } from '@angular/core';

@Component({
  selector: `suka-layout`,
  template: `
    <ng-content></ng-content>
  `
})
export class Layout {
  @HostBinding('class.layout') baseClass = true;
}
